import axios from 'axios';
//import { stringify as qsStringify } from 'querystring';
import axiosConf from '../conf/axios';

let _axios = null;


class SingletonLibrary {

    /**
     * Singleton for axios instance
     */
    static get getAxiosInstance() {
        //-- if axios instance already exist
        if ( _axios === null ){
		    _axios = axios.create({
                baseURL: axiosConf.url,
                timeout: axiosConf.timeout
            });
        }

		return _axios;
    }
    
}


export default SingletonLibrary;


// WEBPACK FOOTER //
// ./src/library/SingletonLibrary.js